<template>
    <section class="testing-position-types section">
        <div class="section__header">
            <h3 class="section__title">{{ getTranslation('serviceType') }} - {{positionTypes.length}}</h3>
        </div>
        <div class="section__body">
            <table class="table-3 table-borderless">
                <thead class="table-3__head">
                    <tr class="table-3__row">
                        <th class="table-3__cell  table__hcell" style="width: 0.1%;">#</th>
                        <th class="table-3__cell  table__hcell" style="width: 20%;">{{ getTranslation('title') }}</th>
                    </tr>
                </thead>
                <tbody class="table-3__body">
                    <tr v-for="item in  positionTypes" v-bind:key="item.id" class="table-3__row">
                        <td class="table-3__cell">
                            <strong>{{item.id}}</strong>
                        </td>
                        <td class="table-3__cell">
                            {{ item.title }}
                        </td>
                    </tr>
                    <tr v-if="positionTypes.length < 1" class="table-3__row">
                        <td colspan="5" class="table-3__cell empty">
                            {{ getTranslation('notAddedYet') }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
    export default {
        name: "PositionTypesComponent",
        props: {
            positionTypes: Array
        }
    }
</script>

<style scoped>

</style>